import React from 'react'
import { Box, Flex } from '@chakra-ui/react'

const LabelIcon = props => {
  return (
    <Flex sx={{ alignItems: 'center' }}>
      <Box
        alignItems="center"
        display="flex"
        flexWrap="no-wrap"
        backgroundColor="blue.500"
        color="white"
        minWidth="48px"
        borderRadius="full"
        justifyContent="center"
        height="48px"
        width="48px"
        {...props}
      >
        {props.children}
      </Box>
      <Box as="span" px={2} fontSize={['lg', 'lg', 'xl']} fontFamily="heading">
        {props.title}
      </Box>
    </Flex>
  )
}

export default LabelIcon
